<ng-container *ngIf="Loading">
    <div class="mt-3" *ngIf="gridData && gridData.length > 0">
        <div role="heading" aria-level="2" aria-label="You are currently on the Play and Earn page" class="bold-500 title-md-bold mt-4 mb-1">Bonus Path</div>
        <div role="heading" aria-level="3" aria-label="Complete offers to unlock bonus savings" class="title-xs-bold color-neutral-700 mb-3">Complete offers to unlock bonus savings</div>
        <deals-grid-al-v1 [gridSettings]="gridSettings" [gridData]="gridData" [calledBy]="calledBy" [logoProps]="logoProps"></deals-grid-al-v1>
    </div>
</ng-container>
